import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const LOGO_URL =
  'https://public.readdy.ai/ai/img_res/22d7b23e-73a2-45c2-bb0a-c05e34d258c7.png';

const navLinks = [
  { label: 'HOME', path: '/' },
  { label: 'ABOUT', path: '/about' },
  { label: 'EMBROIDERY', path: '/embroidery' },
  { label: 'GALLERY', path: '/gallery' },
  { label: 'SHOPPING', path: '/shopping' },
  { label: 'CONTACT', path: '/contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  const isHero = location.pathname === '/';

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const navBg =
    isHero && !scrolled
      ? 'bg-transparent'
      : 'bg-cream shadow-sm';

  const textColor =
    isHero && !scrolled ? 'text-cream/80' : 'text-charcoal/70';

  const activeColor =
    isHero && !scrolled ? 'text-gold' : 'text-gold-dark';

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${navBg}`}
      >
        <div className="flex items-center justify-between px-10 h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3">
            <div className="w-10 h-10 flex items-center justify-center rounded-full overflow-hidden">
              <img
                src={LOGO_URL}
                alt="HivanTex Logo"
                className="w-full h-full object-cover"
              />
            </div>
            <span
              className={`font-serif text-lg tracking-[0.18em] uppercase transition-colors duration-300 ${
                isHero && !scrolled ? 'text-cream' : 'text-charcoal'
              }`}
            >
              HivanTex
            </span>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden lg:flex items-center gap-10">
            {navLinks.map((link) => {
              const isActive = location.pathname === link.path;
              return (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`text-[11px] tracking-[0.18em] font-sans font-light transition-colors duration-200 whitespace-nowrap hover:text-gold ${
                    isActive ? activeColor : textColor
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
          </div>

          {/* Mobile Menu Button */}
          <button
            className={`lg:hidden w-8 h-8 flex items-center justify-center cursor-pointer ${
              isHero && !scrolled ? 'text-cream' : 'text-charcoal'
            }`}
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <i className={`ri-${menuOpen ? 'close' : 'menu'}-line text-xl`} />
          </button>
        </div>

        {/* Gold underline accent */}
        <div
          className={`h-px transition-all duration-500 ${
            scrolled ? 'bg-gold/20' : 'bg-transparent'
          }`}
        />

        {/* Mobile Menu */}
        {menuOpen && (
          <div className="lg:hidden bg-cream border-t border-gold/20 py-6 px-10">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className="block py-3 text-[12px] tracking-[0.18em] font-sans text-charcoal/70 hover:text-gold transition-colors duration-200"
              >
                {link.label}
              </Link>
            ))}
          </div>
        )}
      </nav>
    </>
  );
}
